// @scripts
export type RouteConfig = {
  path: string;
  element: string;
  routes?: RouteConfig[];
};

export type RouteConfigComponentProps = Pick<RouteConfig, 'routes'>;

export const routes: Record<string, RouteConfig> = {
  dashboard: {
    path: '/dashboard',
    element: 'Dashboard'
  },
  siteScheduleDetail: {
    path: '/settings',
    element: 'SiteScheduleDetail'
  }
};

export const routesOutLogged: Record<string, RouteConfig> = {
  login: {
    path: '/',
    element: 'Login'
  },
  forgotPassword: {
    path: '/forgot',
    element: 'ForgotPasswordForm'
  },
  forgotPasswordSendRecovery: {
    path: '/sendRecovery',
    element: 'ForgotPasswordForm'
  },
  changePassword: {
    path: '/changePassword',
    element: 'ChangePasswordForm'
  }
};
